import $ from 'jquery';
import fetch from 'utils/fetch';
import { displayLoader, hideLoader } from './loader';
import { error } from './toastr';

export default function bind() {
  $('button.order').on('click', updateOrder);
}

function updateOrder(evt) {
  const url = $(evt.currentTarget).attr('data-url');
  if (url) {
    evt.preventDefault();
    displayLoader();

    fetch(url, { method: 'PUT' })
      .then(() => window.location.reload(true))
      .catch(err => {
        console.error(err.message);
        error("Une erreur est survenue pendant le changement d'ordre");
        hideLoader();
      });
  }
}



// WEBPACK FOOTER //
// ./src/plugins/order.js